import { DraftCalendarIcon } from '@/components/shared/icons/AddCalendarIcon';
import { PublishedCalendarIcon } from '@/components/shared/icons/PublishedCalendarIcon';
import { FC, JSX } from 'react';
import strings from '../roster.translations';
import { RosterCalendarContextObject, RosterStatus } from './useRosterCalendarEvents';
import { isDateInPast } from '@/helpers/dateHelper';
import { CreateCalendarIcon } from '@/components/shared/icons/CreateCalendarIcon';
import { merge } from '@/helpers/Utility';
import { AutoFillLoader } from '@/components/shared/icons/AutoFillLoader';

interface IconToDisplayProps {
  contextObject?: RosterCalendarContextObject;
  date: Date;
}

export const isPublished = (item: RosterCalendarContextObject) =>
  item.rosterStatus === RosterStatus.published || item.rosterStatus === RosterStatus.republished;

export const IconToDisplay: FC<IconToDisplayProps> = ({ contextObject, date }) => {
  let text: string = '';
  let icon: JSX.Element = <div></div>;

  const inPast = isDateInPast(date, new Date());

  if (contextObject?.rosterStatus === RosterStatus.optimising) {
    icon = <AutoFillLoader />;
    text = strings.autofill;
  } else if (!contextObject?.id) {
    if (!inPast) {
      icon = <CreateCalendarIcon />;
      text = strings.create;
    }
  } else if (isPublished(contextObject)) {
    icon = <PublishedCalendarIcon />;
    text = inPast ? strings.completed : strings.published;
  } else if (contextObject.id) {
    icon = <DraftCalendarIcon />;
    text = strings.draft;
  }

  return (
    <div className={merge('flex flex-col items-center text-gray-500')}>
      {icon}
      <p className="text-xs font-bold">{text.toUpperCase()}</p>
    </div>
  );
};
